import { useEffect, useRef, useState } from "react";
import { Card, Form, Button, Stack } from "react-bootstrap";
import { Pencil } from "react-bootstrap-icons";
import api from "../../../../Services/Api/api";

const EditableTransactionNote = ({ transaction }) => {
  const [note, setNote] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const textareaRef = useRef(null);

  useEffect(() => {
    setNote(transaction?.note || "");
  }, [transaction]);

  // Auto-grow textarea
  useEffect(() => {
    if (!textareaRef.current) return;

    textareaRef.current.style.height = "auto";
    textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
  }, [note, isEditing]);

  const saveNote = async () => {
    try {
      setSaving(true);
      await api.patch(`v1/office/transaction/${transaction._id}/note`, {
        note,
      });
      setIsEditing(false);
    } catch (err) {
      console.error(err);
      window.alert("Failed to update note: " + err.message);
    } finally {
      setSaving(false);
    }
  };

  const cancelEdit = () => {
    setNote(transaction?.note || "");
    setIsEditing(false);
  };

  return (
    <div className="mt-2 mb-2">
      <Stack
        direction="horizontal"
        className="justify-content-between align-items-center mb-0"
      >
        <div className="fw-semibold small">Note: </div>

        {!isEditing && (
          <Button
            style={{ textDecoration: "none", fontSize: "10px" }}
            variant="link"
            size="sm"
            className="p-0"
            onClick={() => setIsEditing(true)}
            title="Edit note"
          >
            <Pencil size={10} />{' '}
            <span>Edit Note</span>
          </Button>
        )}
      </Stack>

      {!isEditing ? (
        <div className="border rounded p-2 small white-space-pre-wrap">
          {note || <span className="text-muted">No note added</span>}
        </div>
      ) : (
        <>
          <Form.Control
            as="textarea"
            ref={textareaRef}
            className="small"
            value={note}
            placeholder="Add notes here..."
            onChange={(e) => setNote(e.target.value)}
            style={{
              resize: "none",
              overflow: "hidden",
            }}
            autoFocus
          />

          <Stack
            direction="horizontal"
            gap={2}
            className="mt-2 justify-content-end"
          >
            <Button variant="secondary" size="sm" onClick={cancelEdit}>
              Cancel
            </Button>

            <Button
              variant="primary"
              size="sm"
              onClick={saveNote}
              disabled={saving}
            >
              {saving ? "Saving..." : "Save"}
            </Button>
          </Stack>
        </>
      )}
    </div>
  );
};

export default EditableTransactionNote;
